import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initFacebookPixels } from './utils/fbPixel';
export function App() {
  useEffect(() => {
    initFacebookPixels();
  }, []);
  return <SalesPage data-id="element-0" />;
}